import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from 'react-redux';
import { AdminApiCall } from '../../../EnvConfig/env_config';
import { adminSessionExpire } from '../../../features/authSlice';
import { FileUploadChild, dateFormateWithTime, handleDateChange, handleDownloadExcel, number, setFocus } from '../../Common/Common';
import { AlertBox, ConfirmAlertBox, DateBox, InputBox, SelectInputBox } from '../../Common/Input';
import Loader from '../../Common/Loader';
import { NewTable } from '../../Common/NewTable';
import { FileUploader } from "react-drag-drop-files";


const PaymentDiscrepancyLogReport = ({ open, setOpen }) => {
    const [edit, setEdit] = useState(false)
    const [showform, setShowForm] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, settableData] = useState([]);
    const [groupNameDropdown, setGroupNameDropdown] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ sortColumn: null, sortOrder: null });
    const [pageSize, setPageSize] = useState("10");
    const [fileName, setFileName] = useState()
    const [filterData, setFilterData] = useState({
        type: "S",
        SearchText: "",
        searchFieldValue: "",
        startValue: "",
    });
    
    const currentDate = new Date();
    const currentDateArr = currentDate.toDateString().split(" ");
    const formattedCurrentDate = `${currentDateArr[2]}-${currentDateArr[1]}-${currentDateArr[3]}`;
    const dateFrom = new Date();
    dateFrom.setDate(dateFrom.getDate() - 7);
    const dateFromArr = dateFrom.toDateString().split(" ");
    const formattedDateFrom = `${dateFromArr[2]}-${dateFromArr[1]}-${dateFromArr[3]}`;

    const [customFilters, setCustomFilters] = useState({
        fromDate: formattedDateFrom,
        toDate: formattedCurrentDate,
        customerEmail: '',
        paymentOrderId: ''
    });
    const dispatch = useDispatch()
    const getUserMasterData = async () => {
        let request = {
            fromDate: customFilters.fromDate,
            toDate: customFilters.toDate,
            customerEmail: customFilters.customerEmail,
            paymentOrderId: customFilters.paymentOrderId,
            ...sortConfig,
            pageIndex: `${currentPageNo}`
        }
        try {
            setIsLoading(true)
            let res = await AdminApiCall('/api/Report/PaymentDiscrepancyLog', { ...request, pageSize: pageSize })
            if (res.Status === 'SUCCESS') {
                settableData(res);
            } else if (res.Status === 'EXPIRED') {
                dispatch(adminSessionExpire({
                    adminSessionExpires: true,
                    status: res.Status,
                    message: res.Message
                }))
            }
            else if (res.Status === 'ERROR') {
                settableData([])
            }
        }
        catch (error) {
            AlertBox('ERROR', 'Failed to show the data. Please try again.')
        }
        finally {
            setIsLoading(false)
        }
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };


    const handleDownLoadExcel = () => {
        let request = {
            fromDate: customFilters.fromDate,
            toDate: customFilters.toDate,
            customerEmail: customFilters.customerEmail,
            paymentOrderId: customFilters.paymentOrderId,
            Type: 'E',
            PageIndex: '1',
            ...sortConfig,
            pageIndex: `${currentPageNo}`,
            pageSize: pageSize
        }
        handleDownloadExcel('/api/Report/PaymentDiscrepancyLog', fileName, request)
    }

    const handleChange1 = (event, pagenumber) => {
        setCurrentPageNo(pagenumber)
    }


    useEffect(() => {
        document.title = 'Payment Discrepancy Log Report'
        setFileName(`Payment Discrepancy Log Report ${dateFormateWithTime(new Date())}`)
        setFocus("txtPromotionName")
        getUserMasterData()
    }, [currentPageNo, sortConfig, pageSize])


    return (
        <div  >
            <main id="main" className={`main ${open ? '' : 'margin_left'}`}  >
                <section className="py-1">
                    <div className='headerbg p-3 d-flex justify-content-between align-items-center'>
                        <h4 className='primary-text'>{'Payment Discrepancy Log Report'}</h4>
                    </div>
                </section>

                <div className="card shadow-sm border-0 mx-2 my-3" style={{ borderRadius: '12px' }}>
                    <div className="card-body py-2">
                        <div className="row align-items-center">
                            <DateBox
                                id='txtFromDate'
                                divclassname="col col-lg-3 fields mt-3"
                                label='Date From'
                                placeholder='Date From'
                                selected={customFilters.fromDate === '' ? '' : new Date(customFilters.fromDate)}
                                onChange={(e) => handleDateChange(e, setCustomFilters, customFilters, 'fromDate')}
                                autoComplete="off"
                            />
                            <DateBox
                                id='txtToDate'
                                divclassname="col col-lg-3 fields mt-3"
                                label='Date To'
                                placeholder='Date To'
                                selected={customFilters.toDate === '' ? '' : new Date(customFilters.toDate)}
                                onChange={(e) => handleDateChange(e, setCustomFilters, customFilters, 'toDate')}
                                autoComplete="off"
                            />
                            <InputBox
                                type="text"
                                id="txtCustomerEmail"
                                divclassname="col-md-3 fields mt-3"
                                label="Customer Email"
                                placeholder="Customer Email"
                                name="customerEmail"
                                value={customFilters.customerEmail}
                                onChange={(e) => setCustomFilters({ ...customFilters, customerEmail: e.target.value })}
                                maxLength="100"
                            />
                            <InputBox
                                type="text"
                                id="txtPaymentOrderId"
                                divclassname="col-md-2 fields mt-3"
                                label="Payment Order ID"
                                placeholder="Payment Order ID"
                                name="paymentOrderId"
                                value={customFilters.paymentOrderId}
                                onChange={(e) => setCustomFilters({ ...customFilters, paymentOrderId: e.target.value })}
                                maxLength="100"
                            />
                            <div className='col-md-1 mt-3 d-flex align-items-end mb-1'>
                                <button className="admin_mybtn mybtn secondary-bg text-dark w-100" style={{ borderRadius: '8px', padding: '8px' }} onClick={() => { setCurrentPageNo(1); getUserMasterData(); }}>
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <NewTable
                    Filter={false}
                    PageName={'PaymentDiscrepancyLog'}
                    handleFilter={() => {
                        getUserMasterData()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                    exportExcelData={true }
                    handleDownLoadExcel={handleDownLoadExcel}
                />
            </main>
            {isLoading && <Loader />}
        </div>

    )
}

export default PaymentDiscrepancyLogReport;






